import React from 'react';

import { FeatureConfig, Vertical } from 'utils/vertical';

type Context = {
  domain: string;
  features: FeatureConfig;
  vertical: Vertical;
};

export const VerticalContext = React.createContext<Partial<Context>>({});

const VerticalProvider: React.FunctionComponent<Context> = ({ children, ...context }) => {
  return <VerticalContext.Provider value={context}>{children}</VerticalContext.Provider>;
};

export default VerticalProvider;
